import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=2c297d10&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=2c297d10&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c297d10')) {
      api.createRecord('2c297d10', component.options)
    } else {
      api.reload('2c297d10', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=2c297d10&", function () {
      api.rerender('2c297d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/script/_id.vue"
export default component.exports